export default __webpack_public_path__ + "static/a9f1b905d47ea96376c02521555beadc.png";